import styled, { keyframes } from "styled-components";

import { ANIMATION } from "../../../utils/constants";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0%;
  animation: ${fadeIn} ${ANIMATION.duration.moderate}
    ${ANIMATION.easing.easeOut};
`;
